module.exports = __webpack_public_path__ + "img/avatar.59569c5b.svg";